import React from "react";

function Login() {
  return (
    <div
      className="min-w-screen min-h-screen  font-nunito text-desc-text z-50 absolute bg-white
    "
    >
      {/* login */}
      <div className="flex justify-between">
        <div className="p-6 md:pl-16 md:pr-0 md:py-16 w-full md:w-2/5">
          <img src="./img/logo-panelo2.png" width="170" alt="" />
          <h1 className="font-bold my-9 text-xl">Login</h1>
          <p className="mb-9 text-lg">
            Don’t have an account?{" "}
            <a className="text-anchor-color" href="/signup">
              Create your account
            </a>{" "}
            it only takes less than a minute!
          </p>

          <form class="bg-white rounded font-poppins">
            <div class="mb-4">
              <label class="block text-gray-500 text-sm  mb-2" for="email">
                Email Address
              </label>
              <input
                class="appearance-none w-full border-b border-main-color py-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="email"
                type="email"
                placeholder="type your email here"
              />
            </div>
            <div class="mb-6">
              <label class="block text-gray-500 text-sm mb-2" for="password">
                Password
              </label>
              <input
                class="appearance-none w-full border-b border-main-color py-2 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                id="password"
                type="password"
                placeholder="type your password here"
              />
            </div>
            <div class="flex items-center justify-between">
              <label class="inline-flex items-center cursor-pointer">
                <input
                  id="customCheckLogin"
                  type="checkbox"
                  class="form-checkbox border-0 rounded w-5 h-5 ease-linear transition-all duration-150"
                />
                <span class="ml-2 text-xs md:text-sm text-blueGray-600">
                  Remember me
                </span>
              </label>
              <button
                class="bg-main-color hover:bg-orange-dark text-white font-bold py-2 px-9 rounded-md focus:outline-none focus:shadow-outline"
                type="button"
              >
                <span className="flex">
                  <p className="mr-2">Login</p>
                  <img src="./img/right-arrow.svg" width="20" alt="" />
                </span>
              </button>
            </div>
          </form>
        </div>

        {/* Login Image */}
        <div className="w-0 hidden md:w-3/5 md:block">
          <img className="h-screen w-full" src="./img/login.png" alt="" />
        </div>
      </div>
    </div>
  );
}

export default Login;
